<template>
  <el-dialog :title="title" v-model="show" size="full" destroyed-on-close=true>
    <div v-loading="loading" :element-loading-text="isEditData === 0 ? '修改保存中。。。' : '新增保存中。。。'">
      <el-row>
        <el-col :span=8>
          <el-form ref="pInfo1" :model="pInfo1" label-width="120px">
            <el-form-item label="guid" class="h20">
              <el-input v-model="pInfo1.guid" placeholder="guid,修改时用"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span=1>
          &nbsp;
        </el-col>
        <el-col :span=15>
          <el-row>
            <span>题目内容</span>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
  import { getSubmitProblemByGuid } from '@/api/api_prepareProblemUser.js'

  export default {
    data () {
      return {
        title: '审核用户提交的题目',
        show: false,
        guid: '',
        isEditData: 0,
        pInfo1: {
          id: 0,
          guid: ''
        }
      }
    },
    computed: {
      title () {

      }
    },
    watch: {
      show: function (val) {

      }
    },
    mounted () { 
      console.log('----here mounted guid=----' )
      this.loadData()
    },
    methods: { 
      closeDlg () {
        this.show = false
      },
      showMsg (msg, type = 'warning') {
        this.$notify({
          title: '审核题目',
          message: msg,
          type: type
        })
      },
      loadData () {
        //dddee
        console.log('----loadData guid=----' + this.guid)
        getSubmitProblemByGuid(this.guid).then((res) => {
          let data = res.data
          console.log('----data=----' + JSON.stringify(data))
          if (data.isOk) {
            console.log('user tm', res.data.data)
          }
        }).catch((err) => {
          this.showMsg(err)
        })
      }
    }
  }
</script>

<style>
  .h20{
    height: 20px;
  }
</style>



// WEBPACK FOOTER //
// main.vue?2d0a82fa